// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"413":"9d48d60c","642":"9d48d60c"}[chunkId] + ".chunk.css";
};